import { Col, Container, Row } from "react-bootstrap";
import GetQuoteForm from "./form/GetQuoteForm";
import MainHeader from "./MainHeader";
import MainBanner from "./MainBanner";
import PackageDetailCard from "./PackageDetailCard";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import TabsNav from "./tabs/TabsNav";
import OverView from "./tabs/OverView";
import Itinerary from "./tabs/Itinerary";
import Inclusions from "./tabs/Inclusions";
import GettingThere from "./tabs/GettingThere";
import PolicyInfo from "./tabs/PolicyInfo";
import FaqPackage from "./tabs/FaqPackage";
import EnquireForm from "./form/EnquireForm";
import PackageDetailCardSkeleton from "components/common/Skeleton/packages/PackageDetailCardSkeleton";
import OverViewSkeleton from "components/common/Skeleton/packages/OverViewSkeleton";
import Discussion from "./common/Discussion";
import MarkFlagModal from "components/SharedSafari/view/common/MarkFlagModal";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import Disclaimer from "./common/Disclaimer";
import { useScreenSize } from "provider/ScreenSizeProvider";
import { useAuth } from "provider/AuthContext";
import { Link } from "react-router-dom";
import OperatorRatingSidebar from "components/operator/OperatorRatingSidebar";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import MobileNoVerificationModal from "components/common/mobilenoverification/MobileNoVerificationModal";


const PackageSafariDetails = () => {
  const { isLoggedIn } = useAuth();
  const { tabKey, packageEnquriToggle, packageViewData, operatorRatingPackage, packageViewLoading } = useSafariPackagesContext();
  const { reportContentToggle } = useSharedSafariContext();
  const { isMobileView } = useScreenSize();




  return (
    <>
      <MainHeader />

      <section className="safari_wrapper  bg-white pt-sm-4 pt-0">
        <Container fluid="xxl">
          <Row className="my-sm-4 mb-4 packageSfari">
            <Col xs={12}>
              {/* <MainBanner /> */}
              <div className="wrapper-skybgsafri pb-0">
                {packageViewLoading ? (
                  <PackageDetailCardSkeleton />
                ) : (
                  <PackageDetailCard />
                )}
                <TabsNav />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="safari_wrapper margin_bottomfooter ">
        <Container fluid="xxl">
          <Row className="mb-5  mt-4 itenary_tabs px-md-3">
            <Col xxl={9} xl={9} xs={12} className="safartabs position-relative order-1">
              {tabKey === "overview" && (
                <>
                  <div
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    className="accordion-item mb-4"
                  >
                    {packageViewLoading ? <OverViewSkeleton /> : <OverView />}

                  </div>
                  {isLoggedIn ?
                    <>
                      {isMobileView && <GetQuoteForm />}
                    </>
                    :
                    <>
                      {isMobileView &&
                        <Link
                          to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/package/${packageViewData?.partner?.slug}/${packageViewData?.package_slug}`)}`}
                          class="sign_intext ">
                          <picture className="position-relative">
                            <source
                              srcSet={"/img/quote_req_small.png"}
                              type="image/png"
                              style={{ borderRadius: "10px" }}
                            />
                            <img
                              src="/img/quote_req_small.png"
                              className="d-block w-100 banner_search"
                              alt="banner"
                              type="image/png"
                              loading="lazy"
                              style={{ borderRadius: "10px" }}
                            />
                          </picture>
                        </Link>
                      }
                    </>
                  }
                  <Discussion />
                </>
              )}
              {tabKey === "itinerary" && (
                <div
                  id="itenery-tab-pane"
                  role="tabpanel"
                  aria-labelledby="itenery-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <Itinerary />
                </div>
              )}
              {tabKey === "inclusions" && (
                <div
                  id="profile-tab-pane"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <Inclusions />
                </div>
              )}
              {tabKey === "getting-there" && (
                <div
                  id="getting-there"
                  role="tabpanel"
                  aria-labelledby="howto-reach"
                  className="tab-pane  accordion-item mb-3 "
                >
                  <GettingThere />
                </div>
              )}
              {/* {tabKey === "accomodation" && (
                <div
                  id="accomodation"
                  role="tabpanel"
                  aria-labelledby="accomodation-tab"
                  className="mb-3"
                >
                  <Accomodation />
                </div>
              )} */}
              {tabKey === "policy-info" && (
                <div
                  id="policy"
                  role="tabpanel"
                  aria-labelledby="policy-tab"
                  className="mb-3"
                >
                  <PolicyInfo />
                </div>
              )}
              {tabKey === "faq" && (
                <div
                  id="faq-tab-pane"
                  role="tabpanel"
                  aria-labelledby="faq-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <FaqPackage />
                </div>
              )}

              <Disclaimer />
            </Col>
            {/* Quote section */}
            <Col xxl={3} xl={3} xs={12} className="mb-2 pb-2 order-2">
              {isLoggedIn ?
                <>
                  {!isMobileView && <GetQuoteForm />}
                  {(isMobileView && tabKey !== "overview") && <GetQuoteForm />}
                </>
                :
                <Link
                  to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/package/${packageViewData?.partner?.slug}/${packageViewData?.package_slug}`)}`}
                  class="sign_intext ">
                  <picture className="position-relative">
                    <source
                      srcSet={"/img/quote_req_small.png"}
                      type="image/png"
                      style={{ borderRadius: "10px" }}
                    />
                    <img
                      src="/img/quote_req_small.png"
                      className="d-block w-100 banner_search"
                      alt="banner"
                      type="image/png"
                      loading="lazy"
                      style={{ borderRadius: "10px" }}
                    />
                  </picture>
                </Link>
              }

              <div className="">
                <OperatorRatingSidebar
                  type={"package"}
                  ratings={operatorRatingPackage}
                  operatorData={packageViewData}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {reportContentToggle && <MarkFlagModal type="packageReport" />}
      {packageEnquriToggle && <EnquireForm />}
    </>
  );
};

export default PackageSafariDetails;
